import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PacoteDossie } from '../models/pacote-dossie.model';
import { PacoteDossieDisponivel } from '../models/pacote-dossie-disponivel.model';
import { PacoteDossieRepository } from '../repositories/pacote-dossie.repository';
import { environment } from '../../../../environments/environment';
import { DEFAULT_PAGINATION_PARAMS, PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { PacoteDossieListParams } from '../models/pacote-dossie-list-params.model';

@Injectable({ providedIn: 'root' })
export class PacoteDossieService implements PacoteDossieRepository {
  private readonly api = 'pacote/';

  constructor(private readonly http: HttpClient) {}

  listarTodos(params: PacoteDossieListParams = { ...DEFAULT_PAGINATION_PARAMS }): Observable<PaginatedResponse<PacoteDossie>> {
    let queryParams = new HttpParams()
      .set('page', params.page)
      .set('size', params.size);
    if (params.pacote?.trim()) queryParams = queryParams.set('pacote', params.pacote.trim());
    if (typeof params.dossie === 'number') queryParams = queryParams.set('dossie', params.dossie);

    return this.http.get<PaginatedResponse<PacoteDossie>>(
      `${environment.FI_FINANC_IMOB_BE}${this.api}listarResumido`,
      { params: queryParams }
    );
  }

  buscarPorId(id: number): Observable<PacoteDossie> {
    return this.http.get<PacoteDossie>(`${environment.FI_FINANC_IMOB_BE}${this.api}buscar/${id}`);
  }

  criar(payload: PacoteDossie): Observable<PacoteDossie> {
    return this.http.post<PacoteDossie>(`${environment.FI_FINANC_IMOB_BE}${this.api}criar`, payload);
  }

  editar(id: number, payload: PacoteDossie): Observable<PacoteDossie> {
    return this.http.put<PacoteDossie>(`${environment.FI_FINANC_IMOB_BE}${this.api}atualizar/${id}`, payload);
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.FI_FINANC_IMOB_BE}${this.api}deletar/${id}`);
  }

  retornaPacotesDossieDisponiveis(dossieId: number, propostaId: string): Observable<PacoteDossieDisponivel[]> {
    return this.http.get<PacoteDossieDisponivel[]>(`${environment.FI_FINANC_IMOB_BE}${this.api}disponiveis/${dossieId}/proposta/${propostaId}`);
  }
}


